import { logger } from '@tuic/logger';

import { Account } from '../../index';

type GetBookingCruisePrice = (args: {
  idToken: string;
  bookingCode: string;
}) => Promise<Account.CruisePriceResponse | null>;

export const getBookingCruisePrice: GetBookingCruisePrice = async ({
  idToken,
  bookingCode,
}) => {
  const { data, error } = await Account.getCruisePrice({
    path: { bookingCode },
    auth: idToken,
  });

  if (error) {
    logger.error('Could not fetch cruise-price data.');
    logger.error(error);

    return null;
  }

  return data ?? null;
};
